import { render, staticRenderFns } from "./RequestsKP.vue?vue&type=template&id=0a3b8ce1&scoped=true&"
import script from "./RequestsKP.vue?vue&type=script&lang=js&"
export * from "./RequestsKP.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a3b8ce1",
  null
  
)

export default component.exports